function getAccessToken() {
    // 1) neuer Standard
    const direct = localStorage.getItem("accessToken");
    if (direct) return direct;

    // 2) alte Variante
    const legacy = localStorage.getItem("token");
    if (legacy) return legacy;

    // 3) AuthContext state
    const authState = localStorage.getItem("auth_state");
    if (authState) {
        try {
            const parsed = JSON.parse(authState);
            return parsed?.accessToken || null;
        } catch {
            return null;
        }
    }

    return null;
}

export async function authFetch(url, options = {}) {
    const token = getAccessToken();

    const headers = { ...(options.headers || {}) };
    if (token) headers["Authorization"] = `Bearer ${token}`;

    return fetch(url, { ...options, headers });
}
